module.exports = __webpack_public_path__ + "static/media/reco_2.fdb3ebaa.jpg";